import format from "date-fns/format"
<template>
  <div class="wholeContext edit">
    <app-sidebar></app-sidebar>
    <app-header :transDataSet="transDate"></app-header>
    <div class="selectRange">
      <h3>수술일정조회</h3>
      <p>조회하실 날짜를 선택해 주세요.</p>
      <div class="datebtnWrap">
        <button type="button" class="direct active" @click="getSettingLogic(0)">직접입력</button>
        <button type="button" class="month" @click="getSettingLogic(1)">1개월</button>
        <button type="button" class="halfYear" @click="getSettingLogic(6)">6개월</button>
        <button type="button" class="whole" @click="getSettingLogic()">전체</button>
        <button type="button" class="" @click="induceClose()">초기화</button>
      </div>
    </div>
    <div class="appContext">
      <div class="datepicker-trigger search">
        <input
          type="text"
          id="datepicker-trigger"
          placeholder="Select dates"
          :value="formatDates(dateOne, dateTwo)"
        >

        <AirbnbStyleDatepicker
          :trigger-element-id="'datepicker-trigger'"
          :mode="'range'"
          :date-one="dateOne"
          :date-two="dateTwo"
          :monthsToShow="1"
          :inline="true"
          :widthSet= this.width
          :showActionButtons="true"
          :customized-dates="[
    { cssClass: 'normal', dates: ['2020-04-20', '2020-04-21'] },
    { cssClass: 'range', dates: ['2020-04-24', '2020-03-25'] }
  ]"
          @cancelled="onClose()"
          :showShortcutsMenuTrigger="false"
          @date-one-selected="val => {
            dateOne = val
          }"
          @date-two-selected="val => {
            dateTwo = val

          }"
          @next-month="val => {
            // this.setPreviosButton(0, val)
            this.getMonthInfo (val)
          }"
          @previous-month="val => {
           // this.setPreviosButton(1, val)
            this.getMonthInfo (val)
          }"
        />
      </div>
      <div class="btnWrap visible" v-if="getWhole">
        <button v-if="dateOne&&dateTwo" type="button" @click="nextDone()">전체 조회하기</button>
        <button v-else type="button" @click="notice">조회하기</button>
      </div>
      <div class="btnWrap visible" v-else>
        <button v-if="dateOne&&dateTwo" type="button" @click="nextDone()">{{dateOne}} ~ {{dateTwo}} 까지 조회하기</button>
        <button v-else type="button" @click="notice">조회하기</button>
      </div>
    </div>
    <add-popup v-if="checkPopup"
               :popupSet="popupSet"/>
  </div>
</template>

<script>
import AppHeader from '@/components/AppHeader'
import AppSidebar from '@/components/AppSidebar'
import AddPopup from '@/components/AddPopup'
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex'
export default {
  data () {
    return {
      popupSet: {
        title: '',
        modalImg: 'alert_cn.svg',
        content: '',
        confirmBtnText: '확인',
        count: 'single',
        closeType: 'close'
      },
      transDate: {
        headerName: '수술일정 조회',
        prevUrl: '/'
      },
      dateFormat: 'D MMM',
      dateOne: '',
      dateTwo: '',
      today: '',
      startDate: '',
      currentMonth: '',
      nextMonth: '',
      defaultMonth: '',
      previousMonth: '',
      getWhole: false,
      popFlag: true,
      width: '',
      dataFlag: false,
      dateStart: '',
      dateEnd: '',
      IsWhole: '',
      monthDate: ''
    }
  },
  created () {
    this.getDefaultDate()
    this.width = window.innerWidth - 40
  },
  computed: {
    ...mapGetters([

    ]),
    ...mapState([
      'checkPopup'
    ])
  },
  methods: {
    ...mapMutations([
      'SET_POPUP',
      'SET_SURGERY_DATE'
    ]),
    ...mapMutations('checkup', [
      'SET_CHECKUP_DATE'
    ]),
    ...mapActions([

    ]),
    induceClose () {
      for (let i = 0; i < 5; i++) {
        document.querySelector('.datebtnWrap button').parentNode.childNodes[i].classList.remove('active')
      }
      document.querySelector('.datebtnWrap button').parentNode.childNodes[4].classList.add('active')
      document.querySelector('.asd__action-buttons button').click()
    },
    getDefaultDate () {
      let date = new Date()
      let monthDate = date.getTime() - (7 * 24 * 60 * 60 * 1000)
      date = this.$moment(date).format('YYYY-MM-DD')
      monthDate = this.$moment(monthDate).format('YYYY-MM-DD')
      // dateMutated = this.$moment(dateMutated).format('YYYY-MM-DD')
      this.monthDate = monthDate
      this.today = date
    },
    getSettingLogic (value) {
      for (let i = 0; i < 5; i++) {
        document.querySelector('.datebtnWrap button').parentNode.childNodes[i].classList.remove('active')
      }
      if (value === 0) {
        document.querySelector('.asd__action-buttons button').click()
        document.querySelector('.datebtnWrap button').parentNode.childNodes[0].classList.add('active')
        this.SET_POPUP(true)
        this.popupSet.content = '조회날짜를 직접 선택해주세요.'
        this.popFlag = true
        this.getWhole = false
        return false
      } else if (value === 1) {
        document.querySelector('.datebtnWrap button').parentNode.childNodes[1].classList.add('active')
      } else if (value === 6) {
        document.querySelector('.datebtnWrap button').parentNode.childNodes[2].classList.add('active')
      } else {
        this.getSettingLogicWhole()
        return false
      }
      this.SET_POPUP(true)
      this.popupSet.content = '조회일이 ' + value + '개월로 설정되었습니다.'
      const date = new Date()
      const monthMutated = date.getMonth() - value
      const dateMutated = new Date(date.getFullYear(), monthMutated, date.getDate())
      console.log('value', value, 'monthMutated', monthMutated)
      console.log('value', value, 'dateMutated', dateMutated)
      this.dateOne = this.date_to_str(dateMutated)
      this.dateTwo = this.today
      this.popFlag = true
      this.getWhole = false
    },
    getSettingLogicWhole () {
      document.querySelector('.datebtnWrap button').parentNode.childNodes[3].classList.add('active')
      this.SET_POPUP(true)
      this.popupSet.content = '조회일이 전체로 설정되었습니다.'
      // 1년
      const date = new Date()
      const startYear = new Date(date.getFullYear(), 11, 31)
      const dateMutated = new Date(date.getFullYear(), 0, 1)
      this.dateOne = this.date_to_str(dateMutated)
      this.dateTwo = this.date_to_str(startYear)
      this.popFlag = true
      this.getWhole = true
    },
    onClose () {
      if (this.popFlag) {
        this.SET_POPUP(true)
        this.popupSet.content = '조회일이 초기화 되었습니다.'
      }
    },
    date_to_str (format) {
      const year = format.getFullYear()
      console.log('year', year)
      let month = format.getMonth() + 1
      if (month < 10) month = '0' + month
      console.log('month', month)
      let date = format.getDate()
      if (date < 10) date = '0' + date
      console.log('date', date)
      return year + '-' + month + '-' + date
    },
    getMonthInfo (val) {
      const currentMonth = Number(val[0].slice(5, 7))
      let nextMonth
      let previousMonth
      this.currentMonth = currentMonth
      if (currentMonth === 12) {
        nextMonth = 1
        previousMonth = currentMonth - 1
      } else if (currentMonth === 1) {
        previousMonth = 12
        nextMonth = currentMonth + 1
      } else {
        nextMonth = currentMonth + 1
        previousMonth = currentMonth - 1
      }
      this.nextMonth = nextMonth
      this.previousMonth = previousMonth
    },
    setPreviosButton (value, val) {
      const yearOrigin = this.today.slice(2, 4)
      const yearParts = String(val).slice(2, 4)
      console.log('재료2', yearOrigin + yearParts)
      if (Number(this.currentMonth) === (Number(this.defaultMonth) + value) && ((Number(this.defaultMonth)) !== Number(this.currentMonth)) && (yearParts === yearOrigin)) {
        document.querySelector('.asd__change-month-button--previous').style.display = 'none'
      } else {
        document.querySelector('.asd__change-month-button--previous').style.display = 'block'
      }
    },
    notice () {
      this.SET_POPUP(true)
      this.popupSet.content = '조회일(시작일, 종료일)을 설정해주세요.'
    },
    formatDates (dateOne, dateTwo) {
      let formattedDates = ''
      if (dateOne) {
        formattedDates = this.$moment(dateOne).format('D MMM')
      }
      if (dateTwo) {
        formattedDates += ' - ' + this.$moment(dateTwo).format('D MMM')
      }
      return formattedDates
    },
    nextDone () {
      const dateList = []
      dateList.push(this.dateOne)
      dateList.push(this.dateTwo)
      dateList.push(this.getWhole)
      this.SET_SURGERY_DATE(dateList)
      history.go(-1)
      // this.$router.push('./checkupList')
    }
  },
  components: {
    AppHeader,
    AppSidebar,
    AddPopup
  }
}
</script>

<style lang="scss" scoped>
</style>
